import type { FC } from 'react'
import { Carousel } from 'components/ui'
import cn from 'classnames'
import { emptyImagePlaceholder } from 'constants/image'
import { slugify } from 'helpers/slugfy'
import type { ProductGalleryProps } from '.'
import s from './product-gallery.module.css'

const responsive = {
  wide: {
    items: 1,
  },
  desktop: {
    items: 1,
  },
  tablet: {
    items: 1,
  },
  mobile: {
    items: 1,
  },
}

const ProductGallery: FC<ProductGalleryProps> = ({ className, ssr = true, images }) => {
  const thumbnails = images.map(({ url }) => url)

  return (
    <div className={cn(s.root, className)}>
      <Carousel
        key="product-gallery"
        config={responsive}
        ssr={ssr}
        className={s.productGallery}
        thumbnails={thumbnails}
        showDots={thumbnails.length > 0}
      >
        {images.map((image) => (
          <div className={s.image} key={`product-gallery-${slugify(image.url)}`}>
            <img src={image.url || emptyImagePlaceholder} alt="" />
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default ProductGallery
